import { EventEmitter, isDevMode, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import * as status from '../../../base/actions/status.actions';
var LoginPageComponent = /** @class */ (function () {
    function LoginPageComponent(store, renderer) {
        this.store = store;
        this.renderer = renderer;
        this.login = new EventEmitter();
        this.loginForm = new FormGroup({
            username: new FormControl(''),
            password: new FormControl('')
        });
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
        // remove header
        this.store.dispatch(new status.SetHeader(false));
    }
    LoginPageComponent.prototype.ngOnInit = function () {
        if (this.devMode) {
            this.loginForm.addControl('tenant', new FormControl(''));
        }
        // add login class to body for background image
        this.renderer.addClass(document.body, 'login');
    };
    LoginPageComponent.prototype.ngOnDestroy = function () {
        // remove login class
        this.renderer.removeClass(document.body, 'login');
    };
    Object.defineProperty(LoginPageComponent.prototype, "devMode", {
        get: function () {
            return isDevMode();
        },
        enumerable: true,
        configurable: true
    });
    LoginPageComponent.prototype.submit = function () {
        if (this.loginForm.valid)
            this.login.emit(this.loginForm.value);
    };
    return LoginPageComponent;
}());
export { LoginPageComponent };
